var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cascade-region"},[(_vm.cascadeOptions.length)?[_c('el-cascader',{ref:"cascaderRef",attrs:{"disabled":_vm.view,"props":_vm.props},on:{"change":_vm.onChangeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }